import { render, staticRenderFns } from "./LandStatistics.vue?vue&type=template&id=5c489800&"
import script from "./LandStatistics.vue?vue&type=script&lang=js&"
export * from "./LandStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports